

export const index = 1;
let component_cache;
export const component = async () => component_cache ??= (await import('../entries/fallbacks/error.svelte.js')).default;
export const imports = ["_app/immutable/nodes/1.4azl2JiR.js","_app/immutable/chunks/stores.CAUBlXQ3.js","_app/immutable/chunks/client.CZs4mqb7.js"];
export const stylesheets = [];
export const fonts = [];
